import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communicationApi, type Message } from '../../api/communication';

export function DeliveryMonitorPage() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void communicationApi.listMessages(100).then((r) => setMessages(r.messages)).catch((e) => setError(String(e)));
  }, []);

  const statusColor = (status: string) => {
    switch (status) {
      case 'delivered': case 'opened': case 'clicked': return 'text-green-600';
      case 'failed': case 'bounced': case 'rejected': return 'text-red-600';
      default: return 'text-slate-600';
    }
  };

  return (
    <div className="mx-auto max-w-5xl p-6">
      <Link to="/communication" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Communication Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Delivery Monitor</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left dark:border-slate-700">
              <th className="p-2">Channel</th>
              <th className="p-2">Subject</th>
              <th className="p-2">Status</th>
              <th className="p-2">Provider</th>
              <th className="p-2">Sent</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((m) => (
              <tr key={m.id} className="border-b dark:border-slate-800">
                <td className="p-2 capitalize">{m.channel}</td>
                <td className="p-2 max-w-xs truncate">{m.subject || m.body.slice(0, 40)}</td>
                <td className={`p-2 font-medium ${statusColor(m.status)}`}>{m.status}</td>
                <td className="p-2">{m.provider || '—'}</td>
                <td className="p-2 text-slate-500">{m.sent_at ? new Date(m.sent_at).toLocaleString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {messages.length === 0 && <p className="mt-4 text-sm text-slate-500">No messages yet</p>}
      </div>
    </div>
  );
}
